__turbopack_context__.v({
  "className": "roboto_flex_c13ce2da-module__YmVTna__className",
});
